var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.signedIn
    ? _c(
        "div",
        { staticStyle: { "overflow-y": "auto" }, attrs: { id: "app" } },
        [
          _c("navbar", { on: { navbarLoading: _vm.handleNavbarLoading } }),
          _c("loading", {
            attrs: { active: _vm.isDataLoaded, "can-cancel": false },
            on: {
              "update:active": function ($event) {
                _vm.isDataLoaded = $event
              },
            },
          }),
          !_vm.isDataLoaded ? _c("router-view") : _vm._e(),
          _c("snackbar"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }